<template>
  <div id="customerId" class="pageOverflow">
    <div v-if="Lib.checkPower('beauty-2-ckgkxx',2)">
      <drawer title="顾客筛选" :display.sync="display">
        <div class="li mb_10">
          <p>顾客性别</p>
          <el-button v-for="(v,n) in items[0]" :key="n" size="small" :type="filter_form.sex == n ? 'primary' : ''" @click="filter_form.sex = n">{{ v }}</el-button>
        </div>
        <div class="li mb_10">
          <p>顾客身份</p>
          <el-button v-for="(v,n) in items[1]" :key="n" size="small" :type="filter_form.memberType == n ? 'primary' : ''" @click="filter_form.memberType = n">{{ v }}</el-button>
        </div>
        <div v-if="filter_form.memberType==1" class="li mb_10">
          <p>会员等级</p>
          <el-button v-for="(v,n) in gradeList" :key="n" size="small" :type="filter_form.level == n ? 'primary' : ''" @click="filter_form.level = n">{{ v }}</el-button>
        </div>
        <div class="li mb_10">
          <p>分销身份</p>
          <el-button v-for="(v,n) in items[8]" :key="n" size="small" :type="filter_form.distribution == (n == 0 ? '' : n) ? 'primary' : ''" @click="filter_form.distribution = (n == 0 ? '' : n)">{{ v }}</el-button>
        </div>
        <div v-if="filter_form.memberType==1" class="li mb_10">
          <p>会员卡办理门店</p>
          <el-select v-model="chooseStoreVal" size="small" style="width: 100%;" multiple placeholder="请选择门店" @change="storeChange">
            <el-option v-for="(v,n) in storeList" :key="n" :label="v.shopName" :value="v.id">
            </el-option>
          </el-select>
        </div>
        <div class="li">
          <p>生日时间</p>
          <el-button v-for="(v,n) in items[4]" :key="n" size="small" :type="filter_form.birthday == n ? 'primary' : ''" @click="filter_form.birthday = n">{{ v }}</el-button>
          <el-date-picker v-model="date" size="small" value-format="MM-dd" format="MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" :clearable="false" @change="onChangeFilterItemTime"></el-date-picker>
        </div>
        <div class="li" style="margin-top: 20px;">
          <p>顾客来源</p>
          <el-button v-for="(v,n) in items[5]" :key="n" size="small" :type="filter_form.source == n ? 'primary' : ''" @click="filter_form.source = n">{{ v }}</el-button>
        </div>
        <div class="li">
          <p>消费频次</p>
          <el-button v-for="(v,n) in items[3]" :key="n" size="small" :type="filter_form.rate == n ? 'primary' : ''" @click="filter_form.rate = n">{{ v }}</el-button>
        </div>
        <div class="li">
          <p>消费金额</p>
          <el-input v-model="filter_form.minPrice" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" maxlength="10" class="input_small" placeholder="最小金额" size="small" @blur="blur($event,1)"></el-input>
          <samp>至</samp>
          <el-input v-model="filter_form.maxPrice" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" maxlength="10" class="input_small" placeholder="最大金额" size="small" @blur="blur($event,2)"></el-input>
        </div>
        <div class="li" style="margin-top: 20px;">
          <p>套餐数量</p>
          <el-input v-model="filter_form.minCount" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" maxlength="4" class="input_small" placeholder="最小数量" size="small" @blur="blur($event,3)"></el-input>
          <samp>至</samp>
          <el-input v-model="filter_form.maxCount" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" maxlength="4" class="input_small" placeholder="最大数量" size="small" @blur="blur($event,4)"></el-input>
        </div>
        <div class="li" style="margin-top: 20px;">
          <p>上次消费时间</p>
          <el-button v-for="(v,n) in items[6]" :key="n" size="small" :type="filter_form.time == n ? 'primary' : ''" @click="filter_form.time = n">{{ v }}</el-button>
          <el-date-picker v-model="consumeDate" size="small" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" :clearable="false" @change="onChangeConsumeDate"></el-date-picker>
        </div>
        <div class="li" style="margin-top: 20px;">
          <p>套餐即将到期时间</p>
          <el-input v-model="filter_form.etMinCount" class="input_small" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" maxlength="4" placeholder="最小天数" size="small" @blur="blur($event,5)"></el-input>
          <samp>至</samp>
          <el-input v-model="filter_form.etMaxCount" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" maxlength="4" class="input_small" placeholder="最大天数" size="small" @blur="blur($event,6)"></el-input>
        </div>
        <div class="li" style="margin-top: 20px;">
          <p>套餐即将到期日期</p>
          <el-button v-for="(v,n) in items[7]" :key="n" size="small" :type="filter_form.edate == n ? 'primary' : ''" @click="filter_form.edate = n">{{ v }}</el-button>
          <el-date-picker v-model="expireDate" size="small" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptionsTwo" :clearable="false" @change="onChangeExpireDate"></el-date-picker>
        </div>
        <div class="li mb_10">
          <p>已购买套餐</p>
          <el-select v-model="buyPackageVal" size="small" style="width: 100%;" multiple placeholder="请选择" @change="storeChange">
            <el-option v-for="(v,n) in buyPackageList" :key="n" :label="v.vipCardName" :value="v.id">
            </el-option>
          </el-select>
        </div>
        <div class="li mb_10">
          <p>未购买套餐</p>
          <el-select v-model="nobuyPackageVal" size="small" style="width: 100%;" multiple placeholder="请选择" @change="storeChange">
            <el-option v-for="(v,n) in nobuyPackageList" :key="n" :label="v.vipCardName" :value="v.id">
            </el-option>
          </el-select>
        </div>
        <div class="dfoot" @click="resetScreen">重置</div>
      </drawer>
      <div class="pageFlex">
        <div class="customer-top">
          <el-input v-model.trim="searchVal" class="ccSearch" size="small" placeholder="请输入名称/手机号码/会员昵称" :maxlength="15" @keyup.enter.native="search">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
          </el-input>
          <i class="el-icon-circle-plus-outline customer-icon" @click="showCustomerDialog"></i>
          <i class="iconfont customer-icon" :style="screenStatus == 1 ? 'color: #f56c6c' : ''" @click="display = true">&#xe63f;</i>
          <el-popover placement="bottom-start" width="180" trigger="click">
            <ul class="file_button_group">
              <li @click="onUploadFiles(1)">导入顾客</li>
              <li @click="onExportCustomerList">导出顾客</li>
              <li @click="onUploadFiles(2)">导入顾客套餐信息</li>
              <li @click="onExportCustomerPackageList">导出顾客套餐信息</li>
              <li @click="onUploadFiles(3)">导入无手机号顾客套餐信息</li>
              <li @click="seeAnalyse">查看顾客分析</li>
              <li @click="getSortType(0,2)"><span v-if="isAsc===0"> </span>列表排序按注册时间降序</li>
              <li @click="getSortType(1,2)"><span v-if="isAsc===1"> </span>列表排序按注册时间升序</li>
            </ul>
            <i slot="reference" class="iconfont customer-icon">&#xe61f;</i>
          </el-popover>
        </div>

        <el-dialog class="memberDialog" :title="form.status == 1 ? '会员充值' : '新增会员'" :visible.sync="form.memberDialog" :append-to-body="true">
          <iframe :src="form.memberManageSrc"></iframe>
        </el-dialog>
        <ul v-if="tableData.length>0" class="customer-ul">
          <li v-for="(item,index) in tableData" :key="index" class="customer-li">
            <ul class="item-box item-top-back">
              <li class="customerInfo">客户信息</li>
              <li>会员信息</li>
              <li>其他信息</li>
              <li>
                资产信息
                <el-tooltip class="item" effect="light" placement="top-start">
                  <div slot="content" class="customerInfo-tisp">
                    <span>有效套餐：</span>指客户的套餐为已拥有的套餐与剩余的可用次数，不包含
                    <br />已用完套餐与已过期套餐
                    <br />
                    <span>将到期套餐：</span>指客户的套餐为已拥有的套餐且有效期≤30天的套餐，
                    <br />请尽快联系客户使用，以免过期造成相互的麻烦
                  </div>
                  <i class="el-icon-warning" style="color:#D2D2D2;font-size:14px;"></i>
                </el-tooltip>
              </li>
              <li>
                门店消费信息
                <el-tooltip class="item" effect="light" placement="top-start">
                  <div slot="content" class="customerInfo-tisp">
                    <span>消费总金额：</span>指客户在当前门店，所有消费的金额汇总，
                    <br />消费总金额=实收金额+划扣金额
                    <br />
                    <span>消费总次数：</span>指客户在当前门店，所有的消费次数的汇总
                  </div>
                  <i class="el-icon-warning" style="color:#D2D2D2;font-size:14px;"></i>
                </el-tooltip>
              </li>
              <li>操作</li>
            </ul>
            <ul class="item-box">
              <li class="flex-row-space-between">
                <div>
                  <div class="customerInfoLeft">
                    <img :src="item.headImgUrl ? (item.headImgUrl+'?x-oss-process=image/resize,m_lfit,w_100') : 'static/images/head.png'" class="customer-img" />
                    <div class="customer-info">
                      <p>{{ item.customerName||'散客' }}</p>
                      <p>{{ Lib.starPhone(item.phone) }}</p>
                    </div>
                  </div>
                  <h5 v-if="item.distributeType == 1 || item.distributeType == 2||item.distributorType == 1">
                    <span v-if="item.distributeType == 1 || item.distributeType == 2" class="item-box-type"> {{ item.distributeType == 2 ? '分销员' : item.distributeType == 1 ? '已绑定分销员' : '' }}</span>
                    <span v-if="item.distributorType == 1" class="item-box-type"> 经销商</span>
                  </h5>
                </div>
              </li>
              <li v-if="item.memberType===1">
                <p>会员等级：{{ item.grade||'--' }}</p>
                <p>会员折扣：{{ item.memberDiscount?item.memberDiscount+'折':'--' }}</p>
                <p>会员余额：￥{{ item.memberMoney||'0' }}</p>
                <p>会员积分：{{ item.memberIntegral||'0' }}</p>
              </li>
              <li v-else>
                <p>会员等级：非会员</p>
              </li>
              <li>
                <p>客户来源：{{ item.source||'--' }}</p>
                <p>注册门店：{{ item.shopName||'--' }}</p>
                <p>注册时间：{{ item.shopTime||'--' }}</p>
              </li>
              <li>
                <p>有效套餐：{{ item.packageCount }}个 <span>{{ item.packageResidueCount===-1?'（无限次数）':`（剩余${item.packageResidueCount}次）` }}</span></p>
                <p>待使用赠品：{{ item.giftResidueCount==-1?'无限次数':item.giftResidueCount+'次' }}</p>
                <p>可用优惠券：{{ item.memberCouponCount||'0' }}张</p>
                <p>将到期套餐：{{ item.minPastTimeCount||'0' }}张</p>
              </li>
              <li>
                <p>消费总金额：¥{{ item.expenseAmount }}</p>
                <p>消费总次数：{{ item.expenseCount }}次</p>
                <p>最近消费时间：{{ item.expenseTime }}</p>
              </li>
              <li class="flex-row-space-between">
                <yz-btn type="primary" @click="customerDetails(item.phone)">详情</yz-btn>
                <yz-btn type="primary" @click="createOrder(item.phone,item.memberName)">开单</yz-btn>
                <el-dropdown>
                  <el-button type="primary" plain size="mini">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" class="customer-dropdown">
                    <el-dropdown-item v-if="item.memberType == 1 && item.isStored == 1" type="delete">
                      <p @click="addMember(1,item.phone)">余额充值</p>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="item.memberType == 0">
                      <p @click="addMember(0,item.phone)">办理会员</p>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <p @click="delCustomer(item)">删除</p>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <p @click="edit(item)">编辑</p>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <p @click="addTab()">派券</p>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
            </ul>
          </li>
        </ul>
        <div v-if="tableData.length == 0" class="noneData">暂无数据</div>
        <gt-delDig @delData="getDelData"></gt-delDig>
        <div v-if="tableData.length > 0" class="allFooter">
          <el-pagination background :current-page.sync="pageNum" :page-size="pageSize" :page-sizes="[5, 10, 15, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
          <i class="iconfont backTop" @click="Lib.backTop()">&#xe62f;</i>
        </div>
      </div>
      <customerDialog v-if="customerVisible" :customer-visible="customerVisible" :title="type" @close="onCloseDialog" />
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import {
  getCustomerMsgListPage,
  getGradeList,
  getMemberUrl,
  getVipCardNameAndIdDTOList,
  getDeleteCustomerInfoStatus,
} from './api';
import customerDialog from './template/customer_detail';
import drawer from '../publicVue/drawer';

export default {
  components: {
    customerDialog,
    drawer
  },
  data() {
    return {
      display: false,

      searchVal: '',
      tableData: [],
      pageNum: 1,
      rowCount: 0,
      pageSize: 10,
      form: {
        memberDialog: false
      },
      date: '',
      // 4.7.0
      filter_form: {
        sex: 0,
        memberType: '',
        level: 0,
        rate: 0,
        birthday: 0,
        source: 0,
        // 6.2
        time: 0,
        minPrice: '', // 最小金额
        maxPrice: '', // 最大金额
        minCount: '', // 最小数量
        maxCount: '', // 最大数量
        // 6.3
        etMinCount: '', // 最小天数
        etMaxCount: '', // 最大天数
        edate: 0,
        // 6.4
        distribution: '', // 分销身份
      },
      items: [
        ['全部', '男', '女', '未知性别'],
        ['全部', '会员', '非会员'],
        ['全部', '1级', '2级', '3级', '4级', '5级', '6级'],
        [
          '全部',
          '1月未消费',
          '2月未消费',
          '3月未消费',
          '6月未消费',
          '1年未消费'
        ],
        ['全部', '今天', '明天', '本周', '本月', '下个月'],
        [
          '全部',
          '电话咨询',
          '顾客介绍',
          '员工介绍',
          '自进店',
          '未知来源'
        ],
        ['全部', '今天', '昨天', '本周', '本月', '上个月'],
        ['全部', '今天', '明天', '本周', '本月', '下个月'],
        ['全部', '已绑定分销关系', '分销员'],
      ],
      showMore: false,
      customerVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      pickerOptionsTwo: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      gradeList: [],
      filePath: '',

      screenStatus: 2, // 筛选状态  1有筛选  2初始
      tooltipStatus: false, // 气泡显示

      // 5.7
      loading: true,
      // 5.8
      processId: '', // 获取随机导入导出id
      timer: null,
      // 6.2
      consumeDate: '', // 上次消费时间
      // 6.3
      storeList: [], // 会员卡办理门店列表
      chooseStoreVal: [], // 会员卡办理门店
      expireDate: '', // 套餐即将到期日期
      // 6.7
      buyPackageVal: [], // 已购买套餐--选择的值
      buyPackageList: [], // 已购买套餐--选择的值
      nobuyPackageVal: [], // 未购买套餐--选择的值
      nobuyPackageList: [], // 未购买套餐--选择的值
      delForm: {
        delDiglogStatus: false,
        title: '',
        id: '',
        url: 'deleteOrder',
        text1: '',
        text2: '',
        status: false
      },
      type: '',
      isAsc: 0, // 是否正序(0:否，1：是)
      sortType: 0, // 排序类型（0：消费日期，1：顾客身份，2：注册时间）不传默认消费日期
    };
  },
  watch: {
    filter_form: {
      handler() {
        if (this.filter_form.sex != 0 || this.filter_form.level != 0 || this.filter_form.memberType != '' || this.filter_form.rate != 0 || this.filter_form.birthday != 0 || this.filter_form.source != 0 || this.filter_form.time != 0 || this.filter_form.minPrice != '' || this.filter_form.maxPrice != '' || this.filter_form.minCount != '' || this.filter_form.maxCount != '' || this.filter_form.etMinCount != '' || this.filter_form.etMaxCount != '' || this.filter_form.edate != 0 || this.filter_form.distribution != '') {
          this.screenStatus = 1;
        } else {
          this.screenStatus = 2;
        }
        this.pageNum = 1;
        this.getCustomerList();
      },
      immediate: false, // 初始化页面马上调用
      deep: true,
    },
    'delForm.status': function (val) {
      if (val == true) {
        this.pageNum = 1;
        this.searchVal = '';
        this.getCustomerList();
        // this.$store.commit('deleteTabs', 'customer-index');
        // this.$router.replace({
        //   name: 'customer-index'
        // });
      }
    },
    'form.memberDialog': function (val) {
      if (val == false) {
        this.getCustomerList();
      }
    }
  },
  activated() {
    this.storeList = JSON.parse(window.sessionStorage.storeList);
    this.searchVal = '';
    this.getCustomerList();
    this.getGradeList();
    this.getPackageList();
  },
  // deactivated() {
  //   this.clearFJ();
  // },
  methods: {
    // 调用公共组件--赋值--5.9
    getDelData(list) {
      this.delForm = list;
    },
    // 删除顾客
    delCustomer(info) {
      const data = {
        busId: window.sessionStorage.busId,
        mainId: window.sessionStorage.mainId,
        phone: info.phone
      };
      getDeleteCustomerInfoStatus(data).then((res) => {
        if (res.code === 0) {
          // （ 1：是 ,-1:非创建顾客的门店不可删除,-2:该顾客已有使用记录，不可删除!，-3：会员顾客不可删除）
          if (res.data == 1) {
            this.delForm.delDiglogStatus = true;
            this.delForm.id = info.phone;
            this.delForm.title = '提示';
            this.delForm.url = 'deleteCustomer';
            this.delForm.text1 = '是否要删除该顾客信息？';
            this.delForm.text2 = '删除后数据不可恢复，请谨慎删除！';
            this.delForm.status = false;
          } else if (res.data == -1) {
            this.$message({ message: '非创建顾客的门店不可删除！', type: 'warning' });
          } else if (res.data == -2) {
            this.$message({ message: '该顾客已有使用记录，不可删除！', type: 'warning' });
          } else if (res.data == -3) {
            this.$message({ message: '会员顾客不可删除！', type: 'warning' });
          }
        }
      });
    },
    // 編輯顾客信息
    edit(item) {
      window.sessionStorage.customerPhone = item.phone;
      this.type = '编辑顾客';
      this.customerVisible = true;
    },
    // 跳转到派券
    addTab() {
      if (this.Lib.checkPower('beauty-2-yhqgl') == false) return;
      this.$router.push({
        name: 'stage-coupon',
        params: {
          activeName: 'first'
        }
      });
    },
    // 查看顾客分销
    seeAnalyse() {
      // 判断权限
      this.$router.push({ name: 'analyse-index' });
    },
    //
    getSortType(isAsc, sortType) {
      this.sortType = sortType;
      this.isAsc = isAsc;
      this.pageNum = 1;
      this.getCustomerList();
    },
    blur(e, val) {
      if (val == 1) {
        this.filter_form.minPrice = e.target.value;
      } else if (val == 2) {
        this.filter_form.maxPrice = e.target.value;
      } else if (val == 3) {
        this.filter_form.minCount = e.target.value;
      } else if (val == 4) {
        this.filter_form.maxCount = e.target.value;
      } else if (val == 5) {
        this.filter_form.etMinCount = e.target.value;
      } else if (val == 6) {
        this.filter_form.etMaxCount = e.target.value;
      }
    },
    // 重置筛选
    resetScreen() {
      this.pageNum = 1;
      this.searchVal = '';
      this.consumeDate = '';
      this.chooseStoreVal = [];
      this.buyPackageVal = [];
      this.nobuyPackageVal = [];
      this.expireDate = '';
      this.filter_form = {
        sex: 0,
        memberType: '',
        level: 0,
        rate: 0,
        birthday: 0,
        source: 0,
        // 6.2
        time: 0,
        minPrice: '', // 最小金额
        maxPrice: '', // 最大金额
        minCount: '', // 最小数量
        maxCount: '', // 最大数量
        // 6.3
        etMinCount: '', // 最小天数
        etMaxCount: '', // 最大天数
        edate: 0,
      };
    },
    // 搜索顾客列表
    search() {
      this.Lib.keyboardBlur();
      this.pageNum = 1;
      this.getCustomerList();
    },
    /* 选择日期 */
    changeDate() {
      this.pageNum = 1;
      this.getCustomerList();
    },
    // 顾客列表
    getCustomerList() {
      this.loading = true;
      // 性别
      let sex = '';
      if (this.filter_form.sex == 1) {
        sex = '男';
      } else if (this.filter_form.sex == 2) {
        sex = '女';
      } else if (this.filter_form.sex == 3) {
        sex = '未知性别';
      } else {
        sex = '';
      }
      // 消费频次
      let rate = '';
      if (this.filter_form.rate == 4) {
        rate = 6;
      } else if (this.filter_form.rate == 5) {
        rate = 12;
      } else {
        rate = this.filter_form.rate == 0 ? '' : this.filter_form.rate;
      }
      // 顾客来源
      let source = '';
      if (this.filter_form.source == 1) {
        source = '电话咨询';
      } else if (this.filter_form.source == 2) {
        source = '顾客介绍';
      } else if (this.filter_form.source == 3) {
        source = '员工介绍';
      } else if (this.filter_form.source == 4) {
        source = '自进店';
      } else if (this.filter_form.source == 5) {
        source = '未知来源';
      } else {
        source = '';
      }
      // 顾客身份
      let memberType = '';
      if (this.filter_form.memberType == 0) {
        memberType = '';
      } else if (this.filter_form.memberType == 1) {
        memberType = 1;
      } else if (this.filter_form.memberType == 2) {
        memberType = 0;
      }
      if (this.filter_form.birthday == 0) {
        this.date = '';
      } else if (this.filter_form.birthday == 1) {
        this.date = [dayjs().format('MM-DD'), dayjs().format('MM-DD')];
      } else if (this.filter_form.birthday == 2) {
        this.date = [dayjs().add(1, 'day').format('MM-DD'), dayjs().add(1, 'day').format('MM-DD')];
      } else if (this.filter_form.birthday == 3) {
        this.date = [dayjs().day(0).format('MM-DD'), dayjs().day(6).format('MM-DD')];
      } else if (this.filter_form.birthday == 4) {
        this.date = [dayjs().startOf('month').format('MM-DD'), dayjs().endOf('month').format('MM-DD')];
      } else if (this.filter_form.birthday == 5) {
        this.date = [dayjs().add(1, 'month').startOf('month').format('MM-DD'), dayjs().add(1, 'month').endOf('month').format('MM-DD')];
      }
      // 上次消费时间
      if (this.filter_form.time == 0) {
        this.consumeDate = '';
      } else if (this.filter_form.time == 1) {
        this.consumeDate = [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')];
      } else if (this.filter_form.time == 2) {
        this.consumeDate = [dayjs().subtract(1, 'day').format('YYYY-MM-DD'), dayjs().subtract(1, 'day').format('YYYY-MM-DD')];
      } else if (this.filter_form.time == 3) {
        this.consumeDate = [dayjs().subtract(7, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')];
      } else if (this.filter_form.time == 4) {
        this.consumeDate = [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD')];
      } else if (this.filter_form.time == 5) {
        this.consumeDate = [dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')];
      }
      // 套餐即将到期日期
      if (this.filter_form.edate == 0) {
        this.expireDate = '';
      } else if (this.filter_form.edate == 1) {
        this.expireDate = [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')];
      } else if (this.filter_form.edate == 2) {
        this.expireDate = [dayjs().add(1, 'day').format('YYYY-MM-DD'), dayjs().add(1, 'day').format('YYYY-MM-DD')];
      } else if (this.filter_form.edate == 3) {
        this.expireDate = [dayjs().day(0).format('YYYY-MM-DD'), dayjs().day(6).format('YYYY-MM-DD')];
      } else if (this.filter_form.edate == 4) {
        this.expireDate = [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD')];
      } else if (this.filter_form.edate == 5) {
        this.expireDate = [dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD'), dayjs().add(1, 'month').endOf('month').format('YYYY-MM-DD')];
      }
      let csvIds = '';
      this.chooseStoreVal.forEach((a, n) => {
        csvIds += `${a}${this.chooseStoreVal.length == (n + 1) ? '' : ','}`;
      });
      const data = {
        asc: '',
        birthdayEnd: this.date ? this.date[1] : '',
        birthdayStart: this.date ? this.date[0] : '',
        busId: sessionStorage.getItem('busId'),
        cardShopIds: csvIds,
        expenseAmountMax: this.filter_form.maxPrice, // 最大消费金额
        expenseAmountMin: this.filter_form.minPrice, // 最小消费金额
        expenseCountMax: this.filter_form.maxCount, // 最大套餐数量
        expenseCountMin: this.filter_form.minCount, // 最小套餐数量
        expenseLastTimeEnd: this.consumeDate ? this.consumeDate[1] : '', // 上次消费结束时间(12-1)
        expenseLastTimeStart: this.consumeDate ? this.consumeDate[0] : '', // 上次消费开始时间(11-1)
        grade: this.gradeList[this.filter_form.level] === '全部' ? '' : this.gradeList[this.filter_form.level],
        mainId: window.sessionStorage.mainId,
        memberType,
        distributeType: this.filter_form.distribution,
        packagePassTimeEndCount: this.filter_form.etMaxCount, // 套餐即将到期时间--最大天数
        packagePassTimeEndTime: this.expireDate ? this.expireDate[1] : '', // 套餐即将到期结束时间
        packagePassTimeStartCount: this.filter_form.etMinCount, // 套餐即将到期时间--最小天数
        packagePassTimeStartTime: this.expireDate ? this.expireDate[0] : '', // 套餐即将到期开始时间
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        phone: this.searchVal,
        rate,
        sex,
        source,
        buyCardList: this.buyPackageVal,
        noBuyCardList: this.nobuyPackageVal,
        isAsc: this.isAsc, // 是否正序(0:否，1：是)
        sortType: this.sortType, // 排序类型（0：消费日期，1：顾客身份，2：注册时间）不传默认消费日期
      };
      getCustomerMsgListPage(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.rowCount = res.data.total;
          this.loading = false;
        } else {
          this.tableData = [];
          this.loading = false;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getCustomerList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getCustomerList();
    },
    // open 新增会员
    addMember(val, phone) {
      if (val == 1) {
        if (this.Lib.checkPower('beauty-2-czhy') == false) return;
      } else if (this.Lib.checkPower('beauty-2-hybl2') == false) return;
      const data = { type: val };
      this.form.status = val;
      getMemberUrl(data).then((res) => {
        if (res.code == 0) {
          this.form.memberManageSrc = `${res.data}?phone=${phone}&hideBack=1&shopId=${window.sessionStorage.shopId}`;
          this.form.memberDialog = true;
        } else {
          console.log(res);
          // this.$message(res.msg)
        }
      });
    },
    // 开单事件
    createOrder(phone, name) {
      if (this.Lib.checkPower('beauty-2-gkkd') == false) return;
      window.sessionStorage.editOrderId = '';
      window.sessionStorage.userName = name;
      window.sessionStorage.userPhone = phone;
      window.sessionStorage.bookOrderId = '';
      this.$router.push({
        name: 'stage-serviceBilling'
      });
    },
    // 4.7.0
    // 顾客详情
    customerDetails(phone) {
      if (this.Lib.checkPower('beauty-2-ckgkxq2') == false) return;
      window.sessionStorage.customerPhone = phone;
      this.$router.push({
        name: 'customer-details'
      });
    },
    // 新增顾客
    showCustomerDialog() {
      if (this.Lib.checkPower('beauty-2-xzgk') == false) return;
      this.type = '新增顾客';
      this.customerVisible = true;
    },
    onCloseDialog(val) {
      this.customerVisible = val;
    },
    // 导出顾客
    onExportCustomerList() {
      if (this.Lib.checkPower('beauty-2-dcgkxx') == false) return;
      // 性别
      let sex = '';
      if (this.filter_form.sex == 1) {
        sex = '男';
      } else if (this.filter_form.sex == 2) {
        sex = '女';
      } else if (this.filter_form.sex == 3) {
        sex = '未知性别';
      } else {
        sex = '';
      }
      // 消费频次
      let rate = '';
      if (this.filter_form.rate == 4) {
        rate = 6;
      } else if (this.filter_form.rate == 5) {
        rate = 12;
      } else {
        rate = this.filter_form.rate == 0 ? '' : this.filter_form.rate;
      }
      let memberType = '';
      if (this.filter_form.memberType == 0) {
        memberType = '';
      } else if (this.filter_form.memberType == 1) {
        memberType = 1;
      } else if (this.filter_form.memberType == 2) {
        memberType = 0;
      }
      // 顾客来源
      let source = '';
      if (this.filter_form.source == 1) {
        source = '电话咨询';
      } else if (this.filter_form.source == 2) {
        source = '顾客介绍';
      } else if (this.filter_form.source == 3) {
        source = '员工介绍';
      } else if (this.filter_form.source == 4) {
        source = '自进店';
      } else if (this.filter_form.source == 5) {
        source = '未知来源';
      } else {
        source = '';
      }

      const data = {
        mainId: window.sessionStorage.mainId,
        sex,
        memberType,
        distributeType: this.filter_form.distribution,
        grade: this.gradeList[this.filter_form.level] === '全部' ? '' : this.gradeList[this.filter_form.level],
        rate,
        birthdayStart: this.date ? this.date[0] : '',
        birthdayEnd: this.date ? this.date[1] : '',
        source,
        pageNum: this.pageNum,
        phone: this.searchVal
      };
      this.$root.$children[0].fatherExport('exportCustomerList', `${this.Lib.A()}/erp/customer/export/exportCustomerList${toQueryString(data)}`);
      // window.location.href = `${this.Lib.A()}/erp/customer/export/exportCustomerList${toQueryString(data)}`;

      function toQueryString(obj) {
        let qstring = '?';
        for (const k in obj) {
          qstring += `${k}=${obj[k]}&`;
        }
        return qstring;
      }
    },
    // 导出顾客套餐信息
    onExportCustomerPackageList() {
      if (this.Lib.checkPower('beauty-2-dcgktcxx') == false) return;
      this.$root.$children[0].fatherExport('exportCustomerPackageList', `${this.Lib.A()}/erp/customer/export/exportCustomerPackageList?mainId=${sessionStorage.getItem('mainId')}`);
      // window.location.href = `${this.Lib.A()}/erp/customer/export/exportCustomerPackageList?mainId=${sessionStorage.getItem('mainId')}`;
    },
    // 获得会员等级列表
    getGradeList() {
      const data = {
        busId: sessionStorage.getItem('busId')
      };
      const vm = this;
      getGradeList(data).then((res) => {
        vm.gradeList = [];
        const nData = res.data || [];
        vm.gradeList.push('全部');
        nData.forEach((x) => {
          vm.gradeList.push(x.gradeName);
        });
      });
    },
    // 获得套餐列表
    getPackageList() {
      const data = {
        mainId: window.sessionStorage.mainId
      };
      const vm = this;
      getVipCardNameAndIdDTOList(data).then((res) => {
        vm.buyPackageList = res.data || [];
        vm.nobuyPackageList = res.data || [];
      });
    },
    onChangeFilterItemTime() {
      this.filter_form.birthday = null;
      this.pageNum = 1;
      this.getCustomerList();
    },
    onChangeConsumeDate() {
      this.filter_form.time = null;
      this.pageNum = 1;
      this.getCustomerList();
    },
    onChangeExpireDate() {
      this.filter_form.edate = null;
      this.pageNum = 1;
      this.getCustomerList();
    },
    storeChange() {
      this.pageNum = 1;
      this.getCustomerList();
    },
    onUploadFiles(val) {
      if (val == 1) {
        if (this.Lib.checkPower('beauty-2-drgkxx') == false) return;
      } else if (val == 2) {
        if (this.Lib.checkPower('beauty-2-drgktcxx') == false) return;
      }
      // else if (val == 3) {
      //   if (this.Lib.checkPower('beauty-2-drwsjhgktcxx') == false) return;
      // }
      this.$root.$children[0].fatherImport(val);
    }
  }
};
</script>
<style lang="less" >
.customer-dropdown .el-dropdown-menu__item{
  padding: 0!important;
}
.customer-dropdown p{
  padding: 0 20px;
}
</style>
<style lang="less" scoped>
.file_button_group {
    list-style: none;
    li {
      position: relative;
      z-index: 99;
      padding: 10px 10px;
      font-size: 13px;
      cursor: pointer;
      &:first-of-type {
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
      }
      &:last-of-type {
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
      }
      span{
        width: 10px;
        height: 10px;
        display: inline-block;
        background: aliceblue;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
}
.el-icon-arrow-down {
    animation: rotater 0.8s forwards;
    @keyframes rotater {
        from {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(0deg);
        }
    }
}
.el-icon-arrow-up {
    animation: rotater2 0.8s forwards;
    @keyframes rotater2 {
        from {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(0deg);
        }
    }
}
.el-dialog__body {
    p {
        margin-bottom: 18px;
        a {
            text-decoration: none;
        }
    }
}
.customer-top {
    height: 32px;
    line-height: 32px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin:5px 0 15px 0;
    .ccSearch {
      width: 260px;
    }
    i {
        height: 20px;
        margin: 0 0 18px 15px;
        line-height: 20px;
        color: #999;
        font-size: 20px;
        cursor: pointer;
        line-height: 32px;
    }
    .customer-icon{
      font-size: 23px;
      line-height: 35px;
    }
}
.customer-ul{
  margin: 20px 0 48px 0;
  padding-right: 2px;
  .customer-li{
    width: 100%;
    border: 1px solid #dfe6ec;
    list-style-type: none;
    margin-bottom: 20px;
    height: auto;
  }
  .customer-img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 10px;
    flex-shrink: 0;
    float: left;
  }
  .customer-info{
    float: left;
    flex: 1;
  }
  .item-box-type{
    font-size: 12px;
    background-color: #000;
    color: #ffc500;
    border-radius: 8px;
    margin: 0 10px 5px 0;
    padding: 4px 10px;
    display: inline-block;
  }
}
.customer-ul .item-top-back{
    background-color: #f5f5f5;
    border-bottom: 1px solid #dfe6ec;
}
/*flex 定位垂直前后环绕*/
.flex-row-space-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.customer-ul .item-box{
  display: flex;
  li{
    font-size: 14px;
    color: #333;
    padding: 15px;
    flex: 1;
    border-right: 1px solid #dfe6ec;
    list-style-type: none;
    .customerInfoLeft {
      display: flex;
      margin-bottom: 10px;
    }
  }
  p{
    line-height: 25px;
    font-size: 14px;
    color: #333;
  }
  li:nth-child(1){
    min-width: calc(20% - 30px);
    max-width: calc(20% - 30px);
  }
  li:nth-child(2){
    min-width: calc(16% - 30px);
    max-width: calc(16% - 30px);
  }
  li:nth-child(3){
    min-width: calc(16% - 30px);
    max-width: calc(16% - 30px);
  }
  li:nth-child(4){
    min-width: calc(16% - 30px);
    max-width: calc(16% - 30px);
  }
  li:nth-child(5){
    min-width: calc(16% - 30px);
    max-width: calc(16% - 30px);
  }
  li:nth-child(6){
    padding: 15px;
    min-width: calc(15% - 30px);
    display: block;
    margin-top: 10px;
    .yz-button {
      margin: 0 10px 20px 0;
      float: left;
    }
  }
}
.noneData{
  margin-top: 54px;
    height: 30px;
    line-height: 30px;
    padding: 30px 0;
    font-size: 14px;
    border-radius: 4px;
    color: #909399;
    text-align: center;
    border: 1px solid #e6ebf5;
}
.customerInfo-tisp{
  line-height: 25px;
  span{
     color: #909399;
  }
}
</style>
